// Defensive wrapper for the QR scanner subtree (slice 4a-7). html5-qrcode
// has known sharp edges (sync throws from stop() in some race conditions,
// MediaStream errors on permission changes) and React 19 surfaces an
// uncaught component error by unmounting the entire app tree — blanking
// the screen. Catching here keeps the rest of the owner shell mounted so
// the user can switch to a different tab.

import { Component, type ReactNode } from 'react'

interface Props {
  children: ReactNode
  /** Called when the boundary catches; lets the caller switch tabs or reset. */
  onError?: (err: unknown) => void
}

interface State {
  caught: boolean
  message: string
}

export class ScannerErrorBoundary extends Component<Props, State> {
  state: State = { caught: false, message: '' }

  static getDerivedStateFromError(err: unknown): State {
    const message =
      err instanceof Error ? err.message : 'Scanner crashed unexpectedly'
    return { caught: true, message }
  }

  componentDidCatch(err: unknown): void {
    this.props.onError?.(err)
  }

  render(): ReactNode {
    if (this.state.caught) {
      return (
        <div className="stamp-scanner">
          <p className="stamp-error">
            The QR scanner ran into a problem ({this.state.message}). Try the
            Card code or Search tab instead, or refresh the page.
          </p>
        </div>
      )
    }
    return this.props.children
  }
}
